import * as React from "react";
import {connect} from "react-redux";
import {Redirect, Route, RouteComponentProps, Switch, withRouter,} from "react-router-dom";
import ClientContractOperationDetail from "src/presentation/container/client_contract_operation_detail";
import ClientContractOperationList from "src/presentation/container/client_contract_operation_list";
import ClientContractOperationReportDetail from "src/presentation/container/client_contract_operation_report_detail";
import ClientContractOperationReportRegistration
    from "src/presentation/container/client_contract_operation_report_registration";
import CustomerContractOperationDetail from "src/presentation/container/customer_contract_operation_detail";
import CustomerContractOperationList from "src/presentation/container/customer_contract_operation_list";
import CustomerContractOperationReportDetail from "src/presentation/container/customer_contract_operation_report_detail";
import CustomerContractOperationReportRegistration
    from "src/presentation/container/customer_contract_operation_report_registration";
import {ClientMarketingCampaignContainer} from "src/presentation/container/client_marketing_campaign";
import CustomerPartnerStore from "src/presentation/container/customer_partner_store";
import CustomerPartnerStoreForm from "src/presentation/container/customer_partner_store_form";
import CustomerPartnerStoreList from "src/presentation/container/customer_partner_store_list";
import CustomerProjectSharing from "src/presentation/container/customer_project_sharing";
import CustomerProjectSharingForm from "src/presentation/container/customer_project_sharing_form";
import {Client, Role as ClientRole} from "../domain/model/client";
import {Customer, Status} from "../domain/model/customer";
import {Role} from "../domain/model/user";
import {AuthStateType} from "./auth_state_type";
import Progress from "./common/organism/progress";
import Auth from "./container/auth_container";
import ClientAgenticSearch from "./container/client_agentic_search";
import ClientBilling from "./container/client_billing_container";
import ClientClientBookmarks from "./container/client_client_bookmarks_container";
import ClientClientBrowsingHistories from "./container/client_client_browsing_histories_container";
import ClientClients from "./container/client_clients_container";
import ClientContract from "./container/client_contract_container";
import ClientContractRegistration from "./container/client_contract_registration";
import ClientCustomer from "./container/client_customer_container";
import ClientEntries from "./container/client_entries_container";
import ClientEntryScoutHistoryList from "./container/client_entry_scout_history_list_container";
import ClientMessageRooms from "./container/client_message_rooms_container";
import ClientMypage from "./container/client_mypage_container";
import ClientNotifications from "./container/client_notifications";
import ClientPmCampaign from "./container/client_pm_campaign_container";
import ClientSalesCampaign from "./container/client_sales_campaign_container";
import ClientIpoCampaign from "./container/client_ipo_campaign_container";
import ClientProject from "./container/client_project_container";
import ClientProjects from "./container/client_projects_container";
import ClientScoutCustomer from "./container/client_scout_customer_container";
import ClientScoutCustomers from "./container/client_scout_customers_container";
import ClientTopPage from "./container/client_top_page_container";
import CustomerBlackListContainer from "./container/cusotmer_black_list_conatainer";
import CustomerContract from "./container/customer_contract_container";
import CustomerContractRegistration from "./container/customer_contract_registration";
import CustomerEntries from "./container/customer_entries_container";
import CustomerMessageRooms from "./container/customer_message_rooms_container";
import CustomerMypage from "./container/customer_mypage_container";
import CustomerNotifications from "./container/customer_notifications";
import CustomerProject from "./container/customer_project_container";
import CustomerProjects from "./container/customer_projects_container";
import CustomerTopPage from "./container/customer_top_page_container";
import CustomerTutorial from "./container/customer_tutorial_container";
import PasswordReset from "./container/password_reset_container";
import {AppState} from "./store/app_state";
import {AuthState} from "./store/auth_state";
import ClientConsultation from "./container/client_consultation";
import ClientConsultationComplete from "./container/client_consultation_complete";
import ClientConsultationForm from "./container/client_consultation_form";

interface IProps extends RouteComponentProps<{}> {
    state: AuthState;
}

interface IState {
}

const RedirectToCustomerPlan = () => {
    return <Redirect to={`/customer/plan`}/>;
};

export class Routing extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const {state, location} = this.props;
        const role: Role = state.user ? state.user.role : Role.Role_Unknown;

        // Customerの状況によりDefaultRouteを変更する
        const customer: Customer | null = state.user && state.user.customer;
        const isStatusInspection: boolean = customer
            ? customer.status === Status.Status_Inspection
            : false;

        // ClientのClientRoleによってRoutingを変更する
        const client: Client | null = state.user && state.user.client;
        const isClientAdmin: boolean = client
            ? client.role === ClientRole.Role_Admin
            : false;

        const params = new URLSearchParams(this.props.location.search);
        const third_party = params.get("third_party");

        if (state.authState === AuthStateType.INITIALIZING) {
            return <Progress canAnimation={false}/>;
        }

        return (
            <React.Fragment>
                {role === Role.Role_Unknown && (
                    <Switch>
                        <Route path="/login" component={Auth}/>
                        <Route path="/customer/_create" component={Auth}/>
                        <Route path="/super_engineer/_create" component={Auth}/>
                        <Route path="/pro/_create" component={Auth}/>
                        <Route path="/apply_client/_register" component={Auth}/>
                        <Route path="/apply_client/_alliance_partner" component={Auth}/>
                        <Route path="/apply_client/lafool/_register" component={Auth}/>
                        <Route
                            path="/apply_client/lafool_medical/_register"
                            component={Auth}
                        />
                        <Route path="/apply_client/thanks" component={Auth}/>
                        <Route path="/passwordreset" component={PasswordReset}/>
                        <Route
                            path="/client/scout/customer/:customerId"
                            component={ClientScoutCustomer}
                        />
                        {third_party === "lafool" && (
                            <Redirect
                                to={{
                                    pathname: "/apply_client/lafool/_register",
                                    state: {from: location},
                                }}
                            />
                        )}
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {from: location},
                            }}
                        />
                    </Switch>
                )}

                {role === Role.Role_Customer && (
                    <Switch>
                        <Route path="/logout" component={Auth}/>
                        <Route exact={true} path="/customer" component={CustomerTopPage}/>

                        <Route path="/customer/entries" component={CustomerEntries}/>
                        <Route
                            exact={true}
                            path="/customer/mypage/customer"
                            component={CustomerMypage}
                        />
                        <Route
                            path="/customer/mypage/customer/:action"
                            component={CustomerMypage}
                        />
                        <Route
                            path="/customer/mypage/password"
                            component={CustomerMypage}
                        />
                        <Route path="/customer/mypage/email" component={CustomerMypage}/>
                        <Route
                            path="/customer/blacklist/:action"
                            component={CustomerBlackListContainer}
                        />
                        <Route path="/customer/projects" component={CustomerProjects}/>
                        <Route
                            path="/customer/project/:projectId"
                            component={CustomerProject}
                        />
                        <Route
                            path="/customer/project-sharing/form"
                            component={CustomerProjectSharingForm}
                        />
                        <Route
                            path="/customer/project-sharing"
                            component={CustomerProjectSharing}
                        />
                        <Route path="/customer/messages" component={CustomerMessageRooms}/>
                        <Route
                            path="/customer/message/:projectId/:customerId/:companyId"
                            component={CustomerMessageRooms}
                        />
                        <Route
                            exact={true}
                            path="/customer/contract/:companyId/:projectId/:customerId"
                            component={CustomerContract}
                        />
                        <Route
                            exact={true}
                            path="/customer/contract/registration/:companyId/:projectId/:customerId"
                            component={CustomerContractRegistration}
                        />
                        {isStatusInspection && (
                            <Route path="/customer/tutorial" component={CustomerTutorial}/>
                        )}
                        <Route
                            exact={true}
                            path="/customer/notifications"
                            component={CustomerNotifications}
                        />
                        <Route
                            exact={true}
                            path="/customer/partner-store"
                            component={CustomerPartnerStore}
                        />
                        <Route
                            exact={true}
                            path="/customer/partner-store-list"
                            component={CustomerPartnerStoreList}
                        />
                        <Route
                            exact={true}
                            path="/customer/partner-store-form/:id"
                            component={CustomerPartnerStoreForm}
                        />
                        <Route
                            exact={true}
                            path="/customer/operations"
                            component={CustomerContractOperationList}
                        />
                        <Route
                            exact={true}
                            path="/customer/operations/:id"
                            component={CustomerContractOperationDetail}
                        />
                        <Route
                            exact={true}
                            path="/customer/operations/:id/report_registration/:ym"
                            component={CustomerContractOperationReportRegistration}
                        />
                        <Route
                            exact={true}
                            path="/customer/operations/:contractId/report/:reportId"
                            component={CustomerContractOperationReportDetail}
                        />
                        <Redirect to="/customer"/>
                    </Switch>
                )}

                {role === Role.Role_Client && (
                    <Switch>
                        <Route path="/logout" component={Auth}/>
                        <Route exact={true} path="/client" component={ClientTopPage}/>
                        <Route
                            path="/client/browsinghistories"
                            component={ClientClientBrowsingHistories}
                        />
                        <Route path="/client/bookmarks" component={ClientClientBookmarks}/>
                        <Route path="/client/billing/plan" component={ClientBilling}/>
                        <Route
                            path="/client/contract/:companyId/:projectId/:customerId/_create"
                            component={ClientContract}
                        />
                        <Route
                            exact={true}
                            path="/client/contract/:companyId/:projectId/:customerId"
                            component={ClientContract}
                        />
                        <Route
                            exact={true}
                            path="/client/contract/registration/:companyId/:projectId/:customerId"
                            component={ClientContractRegistration}
                        />
                        <Route
                            exact={true}
                            path="/client/operations"
                            component={ClientContractOperationList}
                        />
                        <Route
                            exact={true}
                            path="/client/operations/:id"
                            component={ClientContractOperationDetail}
                        />
                        <Route
                            exact={true}
                            path="/client/operations/:id/report_registration/:ym"
                            component={ClientContractOperationReportRegistration}
                        />
                        <Route
                            exact={true}
                            path="/client/operations/:contractId/report/:reportId"
                            component={ClientContractOperationReportDetail}
                        />
                        <Route
                            exact={true}
                            path="/client/mypage/client"
                            component={ClientMypage}
                        />
                        <Route
                            path="/client/mypage/client/:action"
                            component={ClientMypage}
                        />
                        <Route
                            exact={true}
                            path="/client/mypage/company/"
                            component={ClientMypage}
                        />
                        <Route
                            path="/client/mypage/company/:action"
                            component={ClientMypage}
                        />
                        <Route path="/client/mypage/password" component={ClientMypage}/>
                        <Route path="/client/mypage/email" component={ClientMypage}/>
                        <Route path="/client/projects" component={ClientProjects}/>
                        <Route path="/client/entry/:projectId" component={ClientEntries}/>
                        <Route
                            path="/client/project/:mode/:projectId"
                            component={ClientProject}
                        />
                        <Route path="/client/messages" component={ClientMessageRooms}/>
                        <Route
                            path="/client/message/:projectId/:customerId/:companyId"
                            component={ClientMessageRooms}
                        />
                        <Route
                            path="/client/customer/:customerId"
                            component={ClientCustomer}
                        />
                        <Route
                            exact={true}
                            path="/client/agentic-search"
                            component={ClientAgenticSearch}
                        />
                        <Route
                            path="/client/scout/customers"
                            component={ClientScoutCustomers}
                        />
                        <Route
                            path="/client/scout/customer/:customerId"
                            component={ClientScoutCustomer}
                        />
                        <Route path="/client/pm_campaign" component={ClientPmCampaign}/>
                        <Route path="/client/sales_campaign" component={ClientSalesCampaign}/>
                        <Route path="/client/ipo_campaign" component={ClientIpoCampaign}/>
                        <Route
                            path="/client/marketing_campaign"
                            component={ClientMarketingCampaignContainer}
                        />
                        <Route
                            exact={true}
                            path="/client/clients/"
                            component={ClientClients}
                        />
                        <Route path="/client/clients/:action" component={ClientClients}/>
                        <Route
                            exact={true}
                            path="/client/notifications"
                            component={ClientNotifications}
                        />
                        <Route
                            exact={true}
                            path="/client/entry_scout_histories"
                            component={ClientEntryScoutHistoryList}
                        />
                        <Route
                            exact={true}
                            path="/client/consultation/complete"
                            component={ClientConsultationComplete}
                        />
                        <Route
                            exact={true}
                            path="/client/consultation/form"
                            component={ClientConsultationForm}
                        />
                        <Route
                            exact={true}
                            path="/client/consultation"
                            component={ClientConsultation}
                        />
                        <Redirect to="/client"/>
                    </Switch>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.authReducer,
    };
};

export default withRouter(connect(mapStateToProps)(Routing));



// WEBPACK FOOTER //
// ./src/presentation/routing.tsx